import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DashboardService {

    getEventRoute = '/api/newevents/';

    constructor(private dataService: DataService) {
    };

    save(data: any) {
        return this.dataService.post('/api/newevents', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    saveNew(data: any) {
        return this.dataService.post('/api/schedule', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getActualTarget(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/tripentry/targetactual/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.uomtype, refresh);
    }

    getOnDuty(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/vehiclestatus/ondutystatus/' + data.region + '/' + data.division + '/' + data.subdivision, refresh);
    }

    revenueData(data: any, refresh: boolean) {
        // tslint:disable-next-line: max-line-length
        return this.dataService.getData('/api/tripentry/revenue/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.revenueFilterType, refresh);
    }

}
